import { rem } from 'polished'
import React, { memo, useContext } from 'react'
import styled from 'styled-components'

import { mediaQueryUp } from 'components/utils/breakpoint'
import {
  CRUISE_ARRIVAL_PLACE_SEARCH_PLACEHOLDER_LABEL,
  CRUISE_ARRIVAL_PLACE_SEARCH_TITLE_LABEL,
  CRUISE_LOCATION_SEARCH_TYPEAHEAD_TYPES,
  CRUISE_DESTINATION_SEARCH_TYPES,
  SEARCH_DEPARTURE_PORTS,
} from 'constants/cruise'
import TextButton from 'components/Luxkit/Button/TextButton'
import SearchLocationInput from 'components/Search/SearchForm/SearchLocationInput/LocationInput'
import CruiseSearchCruiseLineSelect from './CruiseLines/CruiseSearchCruiseLineSelect'
import CruiseWhenFilter from './CruiseWhenFilter/CruiseWhenFilter'
import { pushWithRegion } from 'actions/NavigationActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import qs from 'qs'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import Places from 'constants/places'

const ControlsContainer = styled.div`
  display: grid;
  gap: ${rem(8)};
  grid-template-columns: 1fr;

  ${mediaQueryUp.sm} {
    gap: ${rem(16)};
    grid-template-columns: 2fr 1fr 1fr ${rem(112)};
  }
`

const LocationContainer = styled.div`
  position: relative;
  display: flex;
  gap: ${rem(16)};

  > * {
    flex-grow: 1;
  }
`

const LocationInput = styled(SearchLocationInput)`
  position: static;

  >:first-child {
    position: static;
  }
`
function CruiseSearchBar() {
  const {
    searchItem,
    secondarySearchItem,
    cruiseLines,
    flexibleMonths,
    durationMax,
    durationMin,
  } = useContext(GlobalSearchStateContext)

  const dispatch = useAppDispatch()

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const destination: App.SearchItem = searchItem ?? {
      value: Places.Anywhere.id,
      format: {
        mainText: 'All destinations',
      },
      searchType: 'destination',
    }

    const query = qs.stringify({
      destinationId: destination.value,
      destinationName: destination.format.mainText,
      portId: secondarySearchItem?.value,
      portName: secondarySearchItem?.format.mainText,
      cruiseLines,
      departureMonths: flexibleMonths || undefined,
      durationMax,
      durationMin,
    }, { arrayFormat: 'repeat' })

    dispatch(pushWithRegion('/search/cruises', query))
  }

  return (<ControlsContainer as="form" onSubmit={onSubmit
  }>
    <LocationContainer>
      <LocationInput
        titleLabel={CRUISE_ARRIVAL_PLACE_SEARCH_TITLE_LABEL}
        placeholder={CRUISE_ARRIVAL_PLACE_SEARCH_PLACEHOLDER_LABEL}
        searchTypes={CRUISE_DESTINATION_SEARCH_TYPES}
        typeaheadTypes={CRUISE_LOCATION_SEARCH_TYPEAHEAD_TYPES}
      />
      <LocationInput
        searchTypes={CRUISE_DESTINATION_SEARCH_TYPES}
        typeaheadTypes={CRUISE_LOCATION_SEARCH_TYPEAHEAD_TYPES}
        titleLabel="Departure port"
        placeholder="All departure ports"
        isSecondaryLocation
        popularPlaces={SEARCH_DEPARTURE_PORTS}
      />
    </LocationContainer>
    <CruiseSearchCruiseLineSelect />
    <CruiseWhenFilter />
    <TextButton
      kind="primary"
      type="submit"
      size="large"
    >
      Search
    </TextButton>
  </ControlsContainer>
  )
}

export default memo(CruiseSearchBar)
